import React, { useRef, useState, useEffect } from 'react';
import './index.scss';
import AudioRtcPlayer from '@/components/AudioRtcPlayer';
import { getClstag } from '@/utils/util';
import { RootState } from '@/redux/store';
import { useSelector } from 'react-redux';
const MicroPhone = (props: { audioUrl: string; closeDropdown: () => void }) => {
  const [open, setOpen] = useState<boolean>(false);
  const audioPlayerRef = useRef<any>(null);
  const newCommon = useSelector((state: RootState) => state.newCommon);

  useEffect(() => {
    return () => {
      if (audioPlayerRef.current?.handlePause) {
        audioPlayerRef.current.handlePause();
      }
    };
  }, []);

  return (
    <>
      <button
        className="vehicle-command-btn"
        clstag={
          !open
            ? getClstag(newCommon.cockpitMode, 'SinglePgae_OpenAudio')
            : getClstag(newCommon.cockpitMode, 'SinglePage_CloseAudio')
        }
        onClick={() => {
          const nextOpen = !open;
          setOpen(nextOpen);
          props.closeDropdown();
          if (!nextOpen && audioPlayerRef.current?.handlePause) {
            audioPlayerRef.current.handlePause();
          }
        }}
      >
        {!open ? '开启收音' : '关闭收音'}
      </button>
      {open && (
        <AudioRtcPlayer
          url={props.audioUrl}
          ref={audioPlayerRef}
          autoPlay={true}
        ></AudioRtcPlayer>
      )}
    </>
  );
};

export default React.memo(MicroPhone);
